import axios from "axios";

const KEY = "AIzaSyDJ8HL36g9TXHS95GtnldmvgmQeKQbOj9I";
 
export default axios.create({
  baseURL: "https://www.googleapis.com/youtube/v3",
  params: {
      part: 'snippet', 
    //   type: 'video',
      maxResults: 5,
      key: KEY
  }
});